module.exports = __webpack_public_path__ + "static/media/ForTheKids.b7acdeaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ForTheKids.jpg
// module id = 344
// module chunks = 0